import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MediaLibraryHttpService } from 'src/app/http/media-library-http.service';
import { EventsService } from 'src/app/services/events.service';
import { SharedService } from 'src/app/services/shared.service';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
import { MediaModalComponent } from 'src/app/shared/modals/media-modal/media-modal.component';
import { Location } from '@angular/common';
import { SectionHttpService } from 'src/app/http/section-http.service';

@UntilDestroy()
@Component({
    selector: 'app-section-edit',
    templateUrl: './section-edit.component.html',
    styles: [],
})
export class SectionEditComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        private sectionHttpService: SectionHttpService,
        private sharedService: SharedService,
        private router: Router,
        public location: Location,
        private mediaLibraryHttpService: MediaLibraryHttpService,
        private modalService: NgbModal,
        private eventsService: EventsService,
        private activatedRoute: ActivatedRoute
    ) {}

    editSectionForm = this.fb.group({
        sectionId: [null],
        sectionName: [null, Validators.required],
        sectionDesc: [null],
        index: [null],
        assetId: [null],
        isFeatured: [false],
        isPublished: [false],
        isSectionOffer: [false],
        sectionOfferProduct: this.fb.array([]),
    });

    section: any;

    selectAsset: any;

    formBusy: boolean;

    products: any[] = [];

    ngOnInit(): void {
        this.routeData();
        this.eventsSub();
        this.isSectionOfferValueChange();
    }

    eventsSub() {
        this.eventsService.trigger.pipe(untilDestroyed(this)).subscribe((data) => {
            if (data.name === 'selectedAsset') {
                const selected = data.value.slice(-1).pop();
                if (selected) {
                    this.selectAsset = selected;
                    this.editSectionForm.controls['assetId'].setValue(selected.assetId);
                }
            }
        });
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.section = data.data[0];
            this.products = data.data[1];
            this.patchForm(data.data[0]);
        });
    }

    patchForm(item: any) {
        this.editSectionForm.patchValue(item);
        if (item.asset) {
            this.selectAsset = item.asset;
        }

        if (item.sectionOfferProduct) {
            let sectionOfferProduct = <FormArray>this.editSectionForm.controls['sectionOfferProduct'];

            item.sectionOfferProduct.forEach((element: any) => {
                sectionOfferProduct.push(
                    this.fb.group({
                        sectionOfferProductId: [element.sectionOfferProductId],
                        sectionId: [element.sectionId],
                        productId: [element.productId],
                    })
                );
            });
        }

        this.addNewEmptyLine();
    }

    onSubmit() {
        this.editSectionForm.markAsTouched();

        if (this.editSectionForm.valid) {
            this.formBusy = true;

            let value = this.editSectionForm.value;

            value.sectionOfferProduct.forEach((element: any) => {
                if (!element.productId) {
                    value.sectionOfferProduct = value.sectionOfferProduct.filter((obj) => obj !== element);
                }
            });

            this.sectionHttpService.editSection(value).subscribe(
                (result) => {
                    this.router.navigateByUrl('section-list', {
                        state: { hasState: true, type: 'success', message: 'Section Edited successfully' },
                    });
                },
                (error) => {
                    this.formBusy = false;
                    this.editSectionForm.setErrors({ exists: true });
                }
            );
        }
    }

    openMedia() {
        this.mediaLibraryHttpService.getAllFolders().subscribe((folders) => {
            let media = this.modalService.open(MediaModalComponent, { size: 'xl', windowClass: 'media-library' });
            media.componentInstance.folders = folders;
        });
    }

    clearImages() {
        this.selectAsset = null;
        this.editSectionForm.controls['assetId'].setValue(null);
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this content item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.sectionHttpService.deleteSection(item.sectionId).subscribe(() => {
            this.router.navigateByUrl('section-list', {
                state: { hasState: true, type: 'success', message: 'Section Deleted successfully' },
            });
        });
    }

    isSectionOfferValueChange() {
        this.editSectionForm.controls['isSectionOffer'].valueChanges.subscribe((data) => {});
    }

    addNewEmptyLine() {
        let sectionOfferProduct = <FormArray>this.editSectionForm.controls['sectionOfferProduct'];
        sectionOfferProduct.push(
            this.fb.group({
                sectionId: [this.section.sectionId],
                productId: [null],
            })
        );
    }

    onProductChange(ev: any, index: number) {
        if (ev) {
            this.addNewEmptyLine();
        }
    }

    deleteLine(index: number) {
        if (this.sectionOfferProduct.length > 1) {
            this.sectionOfferProduct.removeAt(index);
        }
    }

    get sectionOfferProduct() {
        return this.editSectionForm.controls['sectionOfferProduct'] as FormArray;
    }

    ngOnDestroy(): void {
        this.eventsService.trigger.next({ name: null, value: null });
    }
}
